import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { InformationIcon, CheckmarkIcon, WarningIcon, colors, useComponentTheme, breakpoints } from '@chegg-ui/theme';
import { CancelIcon, InfoCircleFillIcon, WarningAltFillIcon, CheckCircleFillIcon, CancelCircleFillIcon } from '@chegg-ui/horizon-icons';
import { SmallNotificationContainer, SmallNotifIconContainer, NotifContent, CloseButton, NotifMessage, SmallNotificationMessageAndCta, getThemeConfig, CloseButtonContainer } from '../styles';
import { NotificationTypes } from '../types';
export var SmallNotificationBanner = function SmallNotificationBanner(_ref) {
  var id = _ref.id,
      type = _ref.type,
      message = _ref.message,
      ctaLink = _ref.ctaLink,
      onCloseClick = _ref.onCloseClick,
      _ref$alignContent = _ref.alignContent,
      alignContent = _ref$alignContent === void 0 ? 'left' : _ref$alignContent,
      iconOverride = _ref.iconOverride,
      dataTest = _ref['data-test'],
      ariaLabel = _ref['aria-label'],
      fluid = _ref.fluid,
      theme = _ref.theme,
      _ref$bannerStyle = _ref.bannerStyle,
      bannerStyle = _ref$bannerStyle === void 0 ? 'global' : _ref$bannerStyle,
      imgSrc = _ref.imgSrc,
      rest = _objectWithoutProperties(_ref, ["id", "type", "message", "ctaLink", "onCloseClick", "alignContent", "iconOverride", "data-test", "aria-label", "fluid", "theme", "bannerStyle", "imgSrc"]);

  var componentTheme = useComponentTheme({
    name: 'NotificatioBanner',
    theme: getThemeConfig(theme)
  });
  var isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia("(max-width: ".concat(breakpoints.sm.max, ")")).matches;
  var notifIcon = iconOverride; // we only consider undefined case as `null` is valid option

  if (iconOverride === undefined) {
    switch (type) {
      case NotificationTypes.Success:
        notifIcon = componentTheme.showHorizonIcons ? /*#__PURE__*/React.createElement(CheckCircleFillIcon, {
          size: isMobile ? 'xsmall' : 'small'
        }) : /*#__PURE__*/React.createElement(CheckmarkIcon, {
          iconFill: "circlefill",
          size: "xsmall"
        });
        break;

      case NotificationTypes.Information:
        notifIcon = componentTheme.showHorizonIcons ? /*#__PURE__*/React.createElement(InfoCircleFillIcon, {
          size: isMobile ? 'xsmall' : 'small'
        }) : /*#__PURE__*/React.createElement(InformationIcon, {
          iconFill: "circlefill",
          size: "xsmall"
        });
        break;

      case NotificationTypes.Error:
        notifIcon = componentTheme.showHorizonIcons ? /*#__PURE__*/React.createElement(CancelCircleFillIcon, {
          size: isMobile ? 'xsmall' : 'small'
        }) : /*#__PURE__*/React.createElement(WarningIcon, {
          iconFill: "circlefill",
          size: "xsmall"
        });
        break;

      default:
        notifIcon = componentTheme.showHorizonIcons ? /*#__PURE__*/React.createElement(WarningAltFillIcon, {
          size: isMobile ? 'xsmall' : 'small'
        }) : /*#__PURE__*/React.createElement(WarningIcon, {
          iconFill: "circlefill",
          size: "xsmall"
        });
        break;
    }
  }

  return /*#__PURE__*/React.createElement(SmallNotificationContainer, _extends({}, rest, {
    id: id,
    type: type,
    "data-test": dataTest ? dataTest : undefined,
    "aria-label": ariaLabel ? ariaLabel : undefined,
    "aria-labelledby": !ariaLabel ? "".concat(id, "-message") : undefined,
    bannerStyle: bannerStyle,
    customTheme: componentTheme,
    src: imgSrc
  }), /*#__PURE__*/React.createElement(NotifContent, {
    hasCloseButton: Boolean(onCloseClick),
    fluid: fluid,
    customTheme: componentTheme
  }, /*#__PURE__*/React.createElement(SmallNotifIconContainer, {
    type: type,
    customTheme: componentTheme,
    bannerStyle: bannerStyle
  }, notifIcon), /*#__PURE__*/React.createElement(SmallNotificationMessageAndCta, {
    alignContent: alignContent,
    customTheme: componentTheme,
    type: type
  }, message ? /*#__PURE__*/React.createElement(NotifMessage, {
    id: "".concat(id, "-message"),
    customTheme: componentTheme,
    type: type,
    "data-test": "notif-message-".concat(dataTest)
  }, message, '\xa0') : null, ctaLink), onCloseClick ? componentTheme.showHorizonIcons ? /*#__PURE__*/React.createElement(CloseButtonContainer, {
    customTheme: componentTheme,
    nType: type,
    size: "xsmall",
    onClick: onCloseClick,
    screenReaderOnlyText: "close",
    variant: "simple"
  }, /*#__PURE__*/React.createElement(CancelIcon, {
    size: "xsmall",
    svgColor: type === NotificationTypes.Guidance || type === NotificationTypes.Moment ? colors.white : colors.grey900
  })) : /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onCloseClick,
    "aria-label": "close"
  }, /*#__PURE__*/React.createElement(CancelIcon, {
    svgColor: colors.dark,
    size: "xsmall"
  })) : undefined));
};
SmallNotificationBanner.displayName = 'SmallNotificationBanner';
export default SmallNotificationBanner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/notification-banner/dist/esm/variants/SmallNotificationBanner.js
// module id = 3345
// module chunks = 11